import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCustomerRetailPricesQueryVariables = Types.Exact<{
  customerId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.SkuUpcMappingFilterInput>;
  order?: Types.InputMaybe<Array<Types.SkuUpcMappingSortInput> | Types.SkuUpcMappingSortInput>;
}>;


export type GetCustomerRetailPricesQuery = { __typename?: 'Query', customerRetailPrices?: { __typename?: 'CustomerRetailPricesConnection', totalCount: number, nodes?: Array<{ __typename?: 'SkuUpcMapping', id: string, tenantId: string, customerItemId: string, itemId: string, customerId: string, customerName: string, locationId?: string | null, locationName: string, sku: string, upc?: string | null, additionalSkus: Array<string>, additionalUpcs: Array<string>, sizeUomCode?: string | null, shippingConfigCategoryCode?: string | null, effectiveShippingUomId?: string | null, effectiveShippingUomSource: Types.ShippingUomSource, program?: string | null, isDefault: boolean, status: Types.CustomerItemStatus, retailShelfPrice?: number | null, retailShelfPriceCurrency?: string | null, effectiveFrom?: Types.TDateISO | null, effectiveUntil?: Types.TDateISO | null, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const GetCustomerRetailPricesDocument = new TypedDocumentString(`
    query GetCustomerRetailPrices($customerId: String!, $first: Int, $after: String, $where: SkuUpcMappingFilterInput, $order: [SkuUpcMappingSortInput!]) {
  customerRetailPrices(
    customerId: $customerId
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      ...SkuUpcMapping
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment SkuUpcMapping on SkuUpcMapping {
  id
  tenantId
  customerItemId
  itemId
  customerId
  customerName
  locationId
  locationName
  sku
  upc
  additionalSkus
  additionalUpcs
  sizeUomCode
  shippingConfigCategoryCode
  effectiveShippingUomId
  effectiveShippingUomSource
  program
  isDefault
  status
  retailShelfPrice
  retailShelfPriceCurrency
  effectiveFrom
  effectiveUntil
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCustomerRetailPrices: build.query<GetCustomerRetailPricesQuery, GetCustomerRetailPricesQueryVariables>({
      query: (variables) => ({ document: GetCustomerRetailPricesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCustomerRetailPricesQuery, useLazyGetCustomerRetailPricesQuery } = injectedRtkApi;
